/**
 * News & Recommendations: layout is CSS-only.
 */
(function () {
  if (typeof wp !== "undefined" && wp.domReady) {
    wp.domReady(function () {
      /* no-op */
    });
  }
})();
